import { CalendarDays, Clock } from 'lucide-react';

import { IMessage } from '@/shared/api/types/chat-message';

import Button from '../../ui/button';

interface Props {
  msg: IMessage;
  onReply: (msg: IMessage) => void;
}

const CalendarMessage = ({ msg, onReply }: Props) => {
  const { text, event } = msg.payload;

  const start = new Date(event.datetime);

  const date = start.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  const time = start.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="flex justify-end mb-6">
      <div className="bg-white border border-gray-200 rounded-xl px-4 py-3 max-w-[360px] shadow-sm flex flex-col gap-1">
        <p className="text-sm text-gray-500">{text}</p>

        <div className="text-base font-medium text-black">{event.title}</div>

        <div className="text-md text-gray-700 flex flex-col gap-2 items-start justify-start">
          <div className="flex items-center text-md gap-2">
            <CalendarDays /> <p>{date}</p>
          </div>
          <div className="flex items-center text-md gap-2">
            <Clock />
            <p>
              {time} · {event.duration_minutes} мин
            </p>
          </div>
        </div>

        {event.topics_summary && (
          <div className="text-md text-gray-600">{event.topics_summary}</div>
        )}

        <div className="flex justify-between max-h-[32px] items-center">
          <Button
            className="text-sm !text-gray-600 cursor-pointer !bg-transparent"
            onClick={() => onReply(msg)}
          >
            ↩ ответить
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CalendarMessage;
